import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export var UserSettingsContext = createContext({});
export var useUserSettingsContext = function () { return useContext(UserSettingsContext); };
var Provider = function (_a) {
    var children = _a.children, userSettings = _a.userSettings;
    return _jsx(UserSettingsContext.Provider, { value: { userSettings: userSettings }, children: children });
};
export default Provider;
